// extracted by mini-css-extract-plugin
export default {"recommendationRenderer":"styles_recommendation-renderer__6euJF","recommendationRenderer__text":"styles_recommendation-renderer__text__V-bTg"};